import createImageUrlBuilder from '@sanity/image-url';
import { sanityConfig } from './config';

export type SanityImageSource = Parameters<typeof imageBuilder.image>[0];

export const imageBuilder = createImageUrlBuilder(sanityConfig);
export const urlForImage = (source: SanityImageSource) =>
  imageBuilder.image(source);
